//Please add the language resource
const shipGroup = {
  schOrderNo:'SchOrderNo',
  orderTypeName:'OrderTypeName',
  itrCode: 'ItrCode',
  ediSoCode: 'EdiSoCode',
  schOrderStatusName: 'SchOrderStatusName',
  customerCode:'CustomerCode',
  businessType:'BusinessType',
  itrYardCode:'ItrYardCode',
  consigneeCode:'ConsigneeCode',
  carrierNo:'CarrierNo',
  planShipTime: 'PlanShipTime',
  planArriveTime:'PlanArriveTime',
  actDispatchTime:'ActDispatchTime',
  actArriveTime:'ActArriveTime',
  expectedDeliveryDate:'ExpectedDeliveryDate',
  epodUploadTime:'EpodUploadTime',
  skuCode:'SkuCode',
  skuQty:'SkuQty',
  vendorCodeForYard: 'VendorCodeForYard',
  poCodeForYard:'PoCodeForYard',
  vendorCodeForCarrier:'VendorCodeForCarrier',
  poCodeForCarrier:'PoCodeForCarrier',
  vendorCodeForSeaTransport:'VendorCodeForSeaTransport',
  poCodeForSeaTransport:'PoCodeForSeaTransport',
  boxConditionName: 'boxConditionName',
  msg:{
  }
};
export default shipGroup



// WEBPACK FOOTER //
// ./src/page/report/shipGroup/lang/shipGroup.en.js